import {
    css, Theme,
} from '@emotion/react'
import common from 'shared/styles'

import custom from 'shared/styles/custom.styles'

const styles = (theme: Theme) => {
    return {
        main: css`
            display: flex;
            flex-grow: 1;
            padding-top: 45px;
        `,
        content: css`
            height: 100%;
            ${common.flexJustityAlignCenter};
            justify-content: space-between;
            flex-direction: column;
            padding: 0 90px;
        `,
        buttons: css`
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            grid-gap: 12px;
            padding-top: 40px;
        `,
        button: custom.button,
        summaryHeader: css`
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            border-bottom: 1px solid ${theme.palette.primary.main};
        `,
        summaryText: css`
            color: ${theme.typography.h3.color};
        `,
        modifiedText: css`
            color: ${theme.typography.h3.color};
            align-self: flex-end;
        `,
        stepContainer: css`
            width: 100%;
            padding-top: 30px;
        `,
        steps: css`
            width: 100%;
            ${custom.boxShadowRadius};
            ${custom.border};
        `,
    }
}

export default styles
